var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("\n        취소 안내\n    ")]),_c('hr'),_c('div',{staticClass:"row"},[_c('pre',{staticStyle:{"white-space":"pre-wrap"},domProps:{"innerHTML":_vm._s(_vm.msg)}},[_vm._v("        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }